import { css, styled } from 'styled-components';

export const EmptyStateCard = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    padding: 24px;
    gap: 24px;

    ${theme.mediaQueries.md} {
      padding: 24px 72px;
      gap: 64px;
      flex-flow: row nowrap;
      justify-content: space-between;
    }
  `}
`;

export const Image = styled.img`
  max-width: 321px;
  width: 321px;
  height: 224px;
  width: 100%;
`;

export const MessageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  gap: 12px;
  padding: 0 auto;
  text-align: left;

  & h3 {
    font-weight: 600;
  }

  & > button {
    margin-top: 8px;
  }
`;
